import { Divider, Grid, useMediaQuery } from '@mui/material'
import React, { useContext } from 'react'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText'
import GlobalButton from '../../utility/globalButton/button'
import globalStyles from "../../../assets/styles/global.module.scss";
import headerStyles from '../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss'
import AddIcon from '@mui/icons-material/Add';
import { useProductStore } from '../../../store/productStore';
import Product from './components/product';
import styles from '../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss'
import { hasProductManageAccess } from '../../../utils/constants';
import { UserContext, UserContextPayload } from '../../../context/userContext';

const ProductGlobal = () => {

    const smallScreen = useMediaQuery('(max-width : 600px) and (min-width : 0px)'); 

    const setFlagCreateProductPopup = useProductStore((state) => state.setFlagCreateProductPopup);
    const { apiRoutesPermissionAssignment, userDetail } = useContext(UserContext) as UserContextPayload;

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container className={globalStyles.headerGlobalPaddingStyle} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container sx={{ alignItems: "center" }} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`}>
                                <GlobalPageHeaderText
                                    mainHeadText={"Product"}
                                    flagMainTextOnly 
                                    actionBlock={
                                        (!smallScreen && hasProductManageAccess(apiRoutesPermissionAssignment, userDetail)) && 
                                        <GlobalButton
                                            buttonText="New Product"
                                            className='primaryButtonStyle'
                                            startIcon={<AddIcon />}
                                            sx={{ width: "170px" }}
                                            onClick={() => setFlagCreateProductPopup(true)}
                                        />
                                    }
                                />
                                {!smallScreen && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.customAPIPageDivider}`} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Grid item xs={12} sm={12} sx={{ padding: "25px 25px 0 27px" }}>
                        <Product />
                    </Grid>

                </Grid>
            </Grid>
        </>
    )
}

export default ProductGlobal
